export function isLocalUrl(url: string | undefined | null): boolean {
   if (!url) {
      return false;
   } else {
      return url === "/"
         || new URL(url, window.location.origin).origin.toUpperCase() == window.location.origin.toUpperCase()
         || !!url.match(/^~?\/[^\/\\]/);
   }
}